<template>
      <div class="hero shop-hero top-hero">
      <div id="hero-bundles">  
        <span>Select bundle:</span><br><br>
        <OptionMenu @on-menu-change="changeBundle" :menu-entries="bundleNames"></OptionMenu>
      </div>
      <div class="shop-hero-middle">
        <Showcase
          :mediaId="bundleShowcaseIds[activeBundle]"
          :key="bundleShowcaseIds[activeBundle]"
          @click="addItemToCart(bundleData[activeBundle]?.name)"
          icon="shop"
          :discount="bundleData[activeBundle]?.total_discount"/>
        </div>
        
        <div v-if="bundleData && bundleData[activeBundle]" id="hero-right">
          <h2 v-html="bundleData[activeBundle]?.name"></h2>
          <div v-if="!isLoggedIn">Already own a product? <a href="#" @click="checkLogin">Log in</a> to get 15% discount on the next.</div>
          <span v-html="bundleData[activeBundle]?.description"></span>
          <div class="flex100-left" style="margin-top: 1rem">
            <PriceDisplay :product="bundleData[activeBundle]" :withSelector="true" />
          </div>
          <div class="flex100-left" style="margin-top: 1rem">
            <a href="javascript:" @click.prevent="checkOutQuick(bundleData[activeBundle].name)" class="fa-btn-cta fa-btn fa-btn-primary buy-now-icon">BUY NOW!</a>
          </div>
          <div v-if="bundleData[activeBundle]?.included_products" class="flex100-left" style="margin-top: 1rem; margin-bottom: 2rem;">
            Contains {{ bundleData[activeBundle].included_products.length }} products worth {{ userStore.formatPriceForUser(calculateBundleWorth(bundleData[activeBundle].included_products)) }}
          </div>
        </div>

    </div>
  <div class="shop-wrap inner-wrap">

        <h1>Shop</h1>
        <div class="discount-reason" style="font-size: 1rem;" v-html="discountReason">                
        </div>
        {{ bundleData[activeBundle]?.name }} contains these individual products:
        <br><br>
      <div class="plugin-card">
        <div class="shop-item-wrapper">
          <div 
            class="plugin-item card-wrap"  
            v-for="plugin in pluginData"  
            :key="plugin.name"
            :class="{ 'no-display': !bundleData[activeBundle] || !bundleData[activeBundle]?.included_products?.includes(plugin.name) }">
            <h3 v-html="plugin?.name"></h3>
            <div class="shop-inner-wrap">
              <div class="download-pic">
                <Showcase 
                  @click="addItemToCart(plugin.name)" 
                  :media-id="plugin.showcaseId" 
                  :discount="plugin?.total_discount"
                  icon="shop"
                  />
              </div>
              <div class="download-links">
                <div class="flex100-left">
                  <PriceDisplay :product="plugin" />
                </div>
                <a 
                  href="javascript:" 
                  @click.prevent="addItemToCart(plugin.name)" 
                  class="fa-btn-cta fa-btn fa-btn-complementary cart-plus-icon" 
                  style="margin-top: 1rem;">
                  ADD TO CART
                </a><br>
                <a 
                   href="javascript:" 
                   @click.prevent="checkOutQuick(plugin.name)" 
                   class="fa-btn-cta fa-btn fa-btn-primary buy-now-icon" 
                   style="margin-top: 1rem;">
                   BUY NOW!
                 </a>
                <div class="download-label">{{ plugin?.shopDesc }}</div>
                <div class="flex100-center" style="margin-top: 1.5rem;">
                  <div class="refund-policy-section" style="font-size: 0.75rem;">
                    <span class="fas fa-shield-alt"></span> <!-- Assuming you're using FontAwesome, a shield indicates protection -->
                    <span>Buy with confidence! We offer a 14-day return policy on plugins. We encourage you to try out and experience our products risk-free.</span>
                  </div>
                </div>
            </div>
            </div>            
          </div>
        </div>       
      </div>
      <div class="plugin-card">
        <div class="shop-item-wrapper">
          <div 
            class="plugin-item card-wrap" 
            v-for="samplepack in samplepackData" 
            :key="samplepack.name"
            :class="{ 'no-display': !bundleData[activeBundle] || !bundleData[activeBundle]?.included_products?.includes(samplepack.name) }">
            <h3 v-html="samplepack?.name"></h3>
            <div class="shop-inner-wrap">
              <div class="download-pic">
                <Showcase 
                  @click="addItemToCart(samplepack.name)" 
                  :media-id="samplepack.showcaseId" 
                  icon="shop"
                  :discount="samplepack?.total_discount"/>
              </div>
              <div class="download-links">
                <div class="flex100-left">
                  <PriceDisplay :product="samplepack" />
                </div>
                 <a 
                   href="javascript:" 
                   @click.prevent="addItemToCart(samplepack.name)" 
                   class="fa-btn-cta fa-btn fa-btn-complementary cart-plus-icon" 
                   style="margin-top: 1rem;">
                   ADD TO CART
                 </a><br>
                 <a 
                   href="javascript:" 
                   @click.prevent="checkOutQuick(samplepack.name)" 
                   class="fa-btn-cta fa-btn fa-btn-primary buy-now-icon" 
                   style="margin-top: 1rem;">
                   BUY NOW!
                 </a>
                <div class="download-label">{{ samplepack?.shopDesc }}</div>
            </div>
            </div>            
          </div>
        </div>       
      </div>
    </div>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue';
import { useDataStore } from '@/store/dataStore';
import { useUserStore } from '@/store/userStore';
import { useCartStore } from '~/store/cartStore';
import { useUIStore } from '~/store/uiStore';
import useBuyNow from '~/composables/useBuyNow';
import { ModalTypes } from '~/types/enums';
import useDiscount from '~/composables/useDiscount';
import { useHead } from '@vueuse/head'

const { discountReason } = useDiscount();

const { buyNowSingle } = useBuyNow();

const cartStore = useCartStore();
const dataStore = useDataStore();
const userStore = useUserStore();
const uiStore = useUIStore();
const activeBundle = ref(0);
const isLoggedIn = computed(() => { return userStore.userData?.is_logged_in || false; });

const bundleShowcaseIds = computed(() => {
  return dataStore.products.bundle.map(bundle => bundle.showcaseId);
});

const checkLogin = () => {
  if (!isLoggedIn.value) {
    uiStore.setModalType(ModalTypes.LOGIN);
  }
};

onMounted(() => {
  dataStore.fetchProductData().then(() => {
    changeBundle({
    "active_entry": 2,
    "active_string": "faTotalBundle"
  });
  });
});

const checkOutQuick = async (product) => {
  console.log("Buying now:", product);
  buyNowSingle(product);
};

const changeBundle = (newValue) => {
  console.log("Changing bundle:", newValue);
  activeBundle.value = newValue.active_entry;
 // bundleMediaId.value = dataStore.products?.bundle[activeBundle.value]?.showcaseId || 0;
};

const addItemToCart = (item) => {
  cartStore.addToCart(item);
};

const calculateBundleWorth = (productNames) => {
  if (!productNames || productNames.length === 0) return { EUR: 0, JPY: 0, USD: 0 };

  const allProducts = [...pluginData.value, ...samplepackData.value];
  return productNames.reduce((acc, productName) => {
    const product = allProducts.find(p => p.name === productName);
    if (!product || !product.price)
    {
      console.log("Product not found:", productName);
      return acc;
    } 

    return {
      EUR: acc.EUR + (product.price.EUR || 0),
      JPY: acc.JPY + (product.price.JPY || 0),
      USD: acc.USD + (product.price.USD || 0)
    };
  }, { EUR: 0, JPY: 0, USD: 0 });
};


const bundleNames = computed(() => dataStore.products?.bundle.map(b => b.name));
const pluginData = computed(() => dataStore.products.plugin);
const samplepackData = computed(() => dataStore.products.samplepack);
const bundleData = computed(() => dataStore.products.bundle);

useHead({
  title: 'Shop Premium Audio Plugins & IR Packs | Forward Audio',
  meta: [
    { 
      name: 'description', 
      content: 'Find top-rated phase alignment plugins, impulse response loader plugins, and exclusive audio plugin bundles at Forward Audio. Shop now for state-of-the-art music production tools!' 
    },
    { 
      property: 'og:type', 
      content: 'product' 
    },
    { 
      property: 'og:title', 
      content: 'Exclusive Audio Plugins & IR Packs | Forward Audio Shop' 
    },
    { 
      property: 'og:description', 
      content: 'Elevate your studio setup with Forward Audio\'s professional-grade phase alignment plugins and impulse response loaders. Discover our bundles for the ultimate sound experience.' 
    },
    { 
      property: 'og:url', 
      content: 'https://www.forward-audio.com/shop' 
    },
    { 
      property: 'og:image', 
      content: 'https://wp.forward-audio.com/wp-content/uploads/2023/10/2023-10-17-01-faTotalBundle-Box.jpg' 
    },
    { 
      property: 'og:site_name', 
      content: 'Forward Audio' 
    },
    { 
      name: 'twitter:card', 
      content: 'summary_large_image' 
    },
    { 
      name: 'twitter:title', 
      content: 'Forward Audio\'s Shop: Premium Audio Plugins & IR Packs' 
    },
    { 
      name: 'twitter:description', 
      content: 'Shop the latest in phase alignment and impulse response technology with Forward Audio. Our bundles offer high-quality, professional audio solutions for every producer.' 
    },
    { 
      name: 'twitter:image', 
      content: 'https://wp.forward-audio.com/wp-content/uploads/2023/10/2023-10-17-01-faTotalBundle-Box.jpg' 
    },
  ]
})


</script>

<style lang="scss" scoped>
@import '~/assets/constants.scss';
// Base pricing styles
span {
    display: inline-block;
    vertical-align: middle;
}

.shop-hero-middle
{
  padding: 2rem;
  padding-top: 0rem;
  padding-right: 0;
}

.no-display {
  display: none;
}

.bundle-option {
  background: $fa-orange;
  border-radius: 5rem;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: bold;
  font-size: 2rem;
  cursor: pointer;
}

.shop-inner-wrap {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 2rem;
  @include respond-to("mobile-only") {
    grid-template-columns: 1fr;
  }
}

.hero-bundles {
      padding: 0rem;
      padding-top: 2rem;
      //display: flex;           /* Enables flex layout */
      //flex-direction: column;  /* Arranges child elements in a column */
      //align-items: flex-end;   /* Aligns child elements to the end of the container */
    }

    .shop-item-wrapper {
    margin-top: 2rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(50rem, 1fr));
    @include respond-to("mobile-only") {
    grid-template-columns: 1fr;
  }
    grid-gap: 2rem;
}

.plugin-item {
  h3 {
    margin-top: 0;
  }
}

.download-label {
  font-style: italic;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.shop-hero {
  grid-template-columns: 20% 50% 30% !important;
  grid-gap: 2rem;

  @media (max-width: 920px) {
    grid-template-columns: 1fr !important;
    .shop-hero-middle
    {
      padding: 0rem;
    }
    
    .hero-right {
      padding-bottom: 2rem;
      align-items: center;
      //margin-top: -1.5rem;
    }
  }
}


.hero-right {
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  //margin-top: -1.5rem;
}

.main-price-display {
  font-size: 1.5rem;
}
</style>
